export const defaultConsoleRole = {
    "id": 102,
    "name": "Console View",
    "custom_group": false,
    "application": {
        "id": 1,
        "name": "Console"
    },
    "group_profile_order": {
        "id": 3,
        "name": "View"
    }
}

export const createUserObj = {
    description:'',
    email:'',
    contact_no:'',
    first_name:'',
    last_name:'',
    reason_for_creation:'',
    designation:'',
    organisation:'',
    security_groups:[defaultConsoleRole],
    user_role:1
}
export const userFilters = {
    'name':{
        'inputType': 'text',
        'title': 'By Name',
    },
    'email':{
        'inputType': 'text',
        'title': 'Email',
    },
    'filter_type':{
        'inputType': 'dropdown',
        'title': 'Status',
        'options':[{label:'Active',value:'active'},{label:'Deactivated',value:'inactive'},{label:'Invitation Sent',value:'invitation-sent'}],
        'labelKey':'label',
        'valueKey':'value'
    },
    'last_login':{
        'inputType': 'dropdown',
        'title': 'Last Login',
        'options':[
            {label:'Any Time',value:'any'},
            {label:'Within Last 7 Days',value:'7_days'},
            {label:'Within Last 30 Days',value:'30_days'},
            {label:'Within Last 90 Days',value:'90_days'},
            {label:'More Than 30 Days Ago',value:'more_than_30_days'},
            {label:'More Than 90 Days Ago',value:'more_than_90_days'},
            {label:'Never Logged In',value:'never'}
        ],
        'labelKey':'label',
        'valueKey':'value'
    }
}